import React, { useState } from 'react';
import SkillsPageContainer from './skills.styles';
import Testimonial from './../../components/testimonial/testimonial.component';
import ProgressHolder from './../../components/progress-holder/progress-holder.component';
import Container from '../../components/container/container.component';
const SkillsPage = () => {
    const [currentTestimonials, setCurrentTestimonials] = useState('two');
    const testimonials = {
        one: [
            {
                imageUrl: 'https://i.ibb.co/ggsCpfk/avatar-01.png',
                text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis, voluptas incidunt ipsa ea officia omnis suscipit possimus eaque est? Alias!',
                jop: 'Nas Dealy, lawyer',
                id: 1,
            },
            {
                imageUrl: 'https://i.ibb.co/6BMDrnm/avatar-02.png',
                text: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis repellat maxime vel asperiores saepe incidunt, voluptates cumque nam quo quod?',
                jop: 'Mosh Rally, Engineer',
                id: 2,
            },
        ],
        two: [
            {
                imageUrl: 'https://i.ibb.co/s3W2gKj/skills-01.jpg',
                text: 'Curabitur arcu erat, accumsan id imperdiet et,porttitor at sem. Mauris blandit aliquet elit,eget tincidunt.',
                jop: 'John Doe, CEO',
                id: 3,
            },
            {
                imageUrl: 'https://i.ibb.co/M1mFG6x/skills-02.jpg',
                text: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Totam a perspiciatis libero saepe? Id officiis similique nesciunt maiores.',
                jop: 'jack pinkman, HR',
                id: 4,
            },
        ],
        three: [
            {
                imageUrl: 'https://i.ibb.co/Lgycbtp/avatar-03.png',
                text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dicta explicabo ex, optio eveniet delectus quibusdam.',
                jop: 'Rash Neff, Doctor',
                id: 5,
            },
            {
                imageUrl: 'https://i.ibb.co/ZYTXCq0/avatar-04.png',
                text: 'Curabitur arcu erat, accumsan id imperdiet et,porttitor at sem. Mauris blandit aliquet elit,eget tincidunt.',
                jop: 'Mhd Ahmed, Surgeon',
                id: 6,
            },
        ],
    };
    const testimonialSlider = (string) => setCurrentTestimonials(string);
    return (
        <SkillsPageContainer id="Skills">
            <Container>
                <div className="container">
                    <div className="testimonials">
                        <h3>Testimonials</h3>
                        <p>
                            Curabitur arcu erat, accumsan id imperdiet et,
                            porttitor at sem. Mauris blandit aliquet elit, eget
                            tincidunt.
                        </p>
                        {testimonials[currentTestimonials].map(
                            ({ id, imageUrl, text, jop }) => (
                                <Testimonial
                                    key={id}
                                    imageUrl={imageUrl}
                                    text={text}
                                    jop={jop}
                                />
                            ),
                        )}
                        <ul className="bullets">
                            <li
                                onClick={() => testimonialSlider('one')}
                                className={
                                    currentTestimonials === 'one'
                                        ? 'active'
                                        : null
                                }
                            ></li>
                            <li
                                onClick={() => testimonialSlider('two')}
                                className={
                                    currentTestimonials === 'two'
                                        ? 'active'
                                        : null
                                }
                            ></li>
                            <li
                                onClick={() => testimonialSlider('three')}
                                className={
                                    currentTestimonials === 'three'
                                        ? 'active'
                                        : null
                                }
                            ></li>
                        </ul>
                    </div>
                    <div className="skills">
                        <h3>Skills</h3>
                        <p>
                            Curabitur arcu erat, accumsan id imperdiet et,
                            porttitor at sem. Mauris blandit aliquet elit, eget
                            tincidunt.
                        </p>
                        <ProgressHolder name="Adobe" progress="90" />
                        <ProgressHolder name="Html &amp; Css" progress="85" />
                        <ProgressHolder name="JavaScript" progress="80" />
                        <ProgressHolder name="PHP" progress="90" />
                    </div>
                </div>
            </Container>
        </SkillsPageContainer>
    );
};
export default SkillsPage;
